import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "./App.scss";
import SingleQR from "./SingleQR";
import MultipleQR from "./MultipleQR";
import MultipleDataMatrix from "./MultipleDataMatrix";
import BarcodeGenerator from "./BarcodeGenerator";
import NotFound from "./NotFound";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";

function AppContent() {
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className={`container page ${isHomePage ? "single-qr-page" : ""}`}
      style={{ paddingBottom: isHomePage && isMobile ? "155px" : "20px" }}
    >
      <Navigation />

      <Routes>
        <Route path="/" element={<SingleQR />} />
        <Route path="/qr-multiple" element={<MultipleQR />} />
        <Route path="/data-matrix" element={<MultipleDataMatrix />} />
        <Route path="/barcode" element={<BarcodeGenerator />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
